export default {
  'label/end_of_trial_counter': 'Su período de prueba ha terminado.',
  'label/end_of_trial_subscribe_now': '¡Suscríbete ahora!',
  'label/trialing_counter': 'Quedan {0} días de tu prueba gratis.',
  'label/trialing_counter_one': 'Queda 1 día de tu prueba gratis.',
  'label/trialing_counter_today': 'Tu prueba gratis termina hoy.',
  'label/trialing_subscribe_now': '¡Suscríbete ahora!',
  'label/credit_card/payment_success_title': '¡Todo bien! Ya puedes usar Doutore :)',
  'label/credit_card/payment_success_text': '¡Tu suscripción ya está activa! Para cualquier sugerencia, duda o problema, nuestro canal de atención por correo electrónico estará siempre disponible.',
  'action/select_a_plan': 'Elige un Plan',
  'action/choose_plan': 'Suscribir',
  'action/payment_success_back': 'Volver a Doutore',
  'label/quest_have_clinic': '¿Tiene una Clínica?',
  'action/contact': 'Ponte en contacto',
  'label/plans': 'Planes',
  'label/web_checkout_note': 'Completas la suscripción en el navegador, con pago seguro con tarjeta de crédito.',
  'label/web_checkout_pending/title': 'Completa tu suscripción en el navegador',
  'label/web_checkout_pending/text': 'Abrimos la página de pago de Doutore en tu navegador. Cuando termines, vuelve a la app: liberamos tu acceso al instante.',
  'action/web_checkout_done': 'Ya me suscribí',
  'action/web_checkout_reopen': 'Abrir el pago de nuevo',
  'label/web_checkout_pending/unconfirmed': 'Todavía no recibimos la confirmación del pago. Si ya pagaste, revisa tu conexión a internet y toca "Ya me suscribí" de nuevo.',
  'label/checking_subscription': 'Verificando...',
  'label/opening_checkout': 'Abriendo...',
  'label/pricing_title': 'Elige tu plan',
  'label/pricing_subtitle': 'Todos los planes incluyen pacientes y secretarias ilimitados, entrenamiento y acceso desde la computadora, iPhone y Android.',
  'label/sms_addon_note': 'Confirmación automática de citas por SMS disponible, cobrada aparte por mensaje enviado.',
  'label/most_popular': 'Más popular',
  'label/per_month': '/mes',
  'label/included_in': 'Lo que incluye el plan {0}',
  'label/tagline/basic': 'Agenda e historia clínica para organizar el consultorio.',
  'label/tagline/complete': 'El consultorio completo, de las recetas a las finanzas.',
  'label/tagline/concierge': 'Para quien atiende en varias clínicas y quiere prioridad.',
  'label/feature/agenda_records': 'Agenda e historia clínica electrónica',
  'label/feature/one_professional': '1 profesional de la salud',
  'label/feature/chat_email_support': 'Soporte por chat y email',
  'label/feature/everything_in_basic': 'Todo lo del Básico, y además:',
  'label/feature/e_prescriptions': 'Recetas electrónicas',
  'label/feature/forms': 'Anamnesis y otros formularios',
  'label/feature/financial': 'Control financiero',
  'label/feature/storage_20gb': '20 GB de almacenamiento',
  'label/feature/everything_in_complete': 'Todo lo del Completo, y además:',
  'label/feature/custom_forms': 'Formularios personalizados',
  'label/feature/multiple_clinics': 'Control de varias clínicas',
  'label/feature/storage_100gb': '100 GB de almacenamiento',
  'label/feature/priority_support': 'Soporte prioritario por chat, email y WhatsApp',
  'label/clinic_cta_text': 'Armamos un plan para tu equipo, con varios profesionales.',
  'label/web_checkout_short': 'Pago seguro en el navegador',
  'action/subscribe_plan': 'Suscribir {0} · {1}/mes',
  // An iOS build in App Store review: no plans, prices or purchase
  'store_review/trialing_title': 'Estás en el período de prueba',
  'store_review/ended_title': 'Tu acceso a Doutore no está activo',
  'store_review/ended_text': 'Si necesitas ayuda con tu cuenta, habla con nuestro equipo.',
  'store_review/support': 'Hablar con soporte',
  'store_review/logout': 'Salir de Doutore',
};
